import { EventsDTO, EventsFlatDTO } from "../domain/models/dto/EventsDTO";
import { EventsFlatCollection, IEventFlat } from "../domain/models/Events";
import { EventsService } from "../domain/services/EventsService";
import { EventsFlatMapper } from "../mappers/EventsFlatMapper";
import { BaseServiceImpl } from "./BaseServiceImpl";
import { LanguageServiceImpl } from "./LanguageServiceImpl";

export class EventsServiceImpl extends BaseServiceImpl implements EventsService {
    static _instance: EventsService;
    private readonly eventsEndpoint = "/api/v1/events";

    private constructor() {
        super();
    }

    static getInstance(): EventsService {
        if (!EventsServiceImpl._instance) {
            EventsServiceImpl._instance = new EventsServiceImpl();
        }
        return EventsServiceImpl._instance;
    }

    async getAllEvents(
        currentPage: number,
        currentLimit: number,
        filtersDTO: EventsDTO = {} as EventsDTO
    ): Promise<EventsFlatCollection> {
        try {
            let url = `${this.eventsEndpoint}?page=${currentPage}&limit=${currentLimit}&lang=${LanguageServiceImpl.getInstance().currentLang}&getEntityTranslations=false`;

            Object.entries(filtersDTO).forEach(([key, value]) => {
                if (key && value !== null && value !== undefined) {
                    url += `&${key}=${value}`;
                }
            });

            const result = await this.get<EventsFlatCollection>(url);

            return {
                ...result,
                rows: result.rows.map((dto: EventsFlatDTO) =>
                    new EventsFlatMapper().fromDTO(dto)
                ),
            };
        } catch (err) {
            console.log("Error in EventsServiceImpl.getAllEvents");
            console.log(err);
            throw err;
        }
    }

    async getEventById(id: string): Promise<IEventFlat | null> {
        try {
            if (!id) return null;

            const dto = await this.get<EventsFlatDTO>(
                `${this.eventsEndpoint}/${id}?lang=${LanguageServiceImpl.getInstance().currentLang}`
            );
            return new EventsFlatMapper().fromDTO(dto);
        } catch (err) {
            console.log("Error in EventsServiceImpl.getEventById");
            console.log(err);
            return null;
        }
    }
}

export function eventsServiceFactory(): EventsService {
    return EventsServiceImpl.getInstance();
}


